import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-base-form',
    template: ``,
    standalone: false
})
export class BaseSelectionListProperties {
  @Input('label') input_label: string;
  @Input() loading: boolean = false;
  @Input('searchLabel') input_searchLabel: string;
  @Input('searchBoxGridClass') input_searchBoxGridClass: string =
    'sm:tw-w-1/2 sm:tw-pl-[25px] sm:ltr:tw-pr-[25px]';
  @Input('responsiveClass') input_responsiveClass: string =
    'sm:tw-w-1/2 xl:tw-w-1/3 xl:tw-w-1/4';
  @Input('optionCustomClass') input_optionCustomClass: string = '';
  @Input('listOptionCustomClass') input_listOptionCustomClass: string = '';

  @Input('form') input_form: FormGroup;
  @Input('controlName') input_formControlName: string;

  @Input() values: any[] = []; //selected items
  @Input() items: any[] = [];
  @Input() customSortArray: any[] = [];
  @Input() id: number | string;
  @Input() optionTitle: string;
  @Input() optionValue: string;
  @Input() maxHeight: string;
  @Input() sortKey: string;
  @Input() isSmallSize: boolean = false;
  @Input() isRoleOrganizationForm: boolean = false;
  @Input() isDisableSelectedItem: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() isShowSelectAll: boolean = true;
  @Input() isFixedSearchBox: boolean = false;
  @Input() isShowOptionCheckBox: boolean = true;

  @Input() isRequired: boolean = false;

  @Output('values') output_values = new EventEmitter<any[]>();
  @Output('items') output_items = new EventEmitter<any[]>();
  @Output('clickedOption') output_clickedOption = new EventEmitter<any>();

  protected onDestroy$ = new Subject<void>();
  @Input() maxShowItemInDisplay: number = 0;

  constructor() {}
}
